import VirtualDomLayer from './VirtualDomLayer';

export default class VirtualDom {
  private layers: VirtualDomLayer[];
  layersByName: object;

  constructor() {
    this.layers = [];
    this.layersByName = {};
  }

  registerLayer(layer: VirtualDomLayer) {
    this.layersByName[layer.getName()] = layer;
    this.layers.push(layer);
  }

  draw(viewPort, zoomLevel, ctx, transform, scaling, renderingState) {
    for (const layer of this.layers) {
      if (transform.k <= 1) {
        if (layer.showAtInitialZoom()) {
          layer.drawElementsInViewPort(
            viewPort,
            ctx,
            transform,
            scaling,
            renderingState,
          );
        }
      } else {
        if (layer.isVisible(zoomLevel)) {
          const _opacityBefore = ctx.globalAlpha;
          ctx.globalAlpha = layer.getOpacity(zoomLevel);
          layer.drawElementsInViewPort(
            viewPort,
            ctx,
            transform,
            scaling,
            renderingState,
          );
          ctx.globalAlpha = _opacityBefore;
        }
      }
    }
  }

  getLayer(name): VirtualDomLayer {
    if (name in this.layersByName) {
      return this.layersByName[name];
    } else {
      return new VirtualDomLayer({ name: '' });
    }
  }
}
